import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const SEOHelmet = ({
  title,
  description,
  image = "https://aubinsiaha.maautek.com/og-image.png",
  url = "https://aubinsiaha.maautek.com",
}) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || "en";

  const defaultTitle =
    currentLang === "fr"
      ? "Aubin SIAHA | Ingénieur Informaticien & Développeur Full Stack"
      : "Aubin SIAHA | Software Engineer & Full Stack Developer";

  const defaultDesc =
    currentLang === "fr"
      ? "Portfolio professionnel de Aubin SIAHA, Développeur Full Stack passionné par le développement d'applications web modernes, performantes et sécurisées."
      : "Official portfolio of Aubin SIAHA, Full Stack Software Engineer crafting responsive web applications, robust REST APIs, and modern digital solutions.";

  const pageTitle = title ? `${title} | Aubin SIAHA` : defaultTitle;
  const pageDesc = description || defaultDesc;

  return (
    <Helmet>
      <html lang={currentLang} />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#070a12" />

      {/* OpenGraph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content="@aubinsiaha" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEOHelmet;
